module.exports = __webpack_public_path__ + "static/media/Sharp-LQ104S1LG81-Mechanical-Drawing.ebc84581.gif";